import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Chart } from 'sharedComponents/Chart';
import { CHART_PLUGINS } from 'sharedComponents/Chart/constants';
import { LoadingIndicator } from 'sharedComponents/PowertrainLoadingIndicator';
import useChartResize from 'sharedHooks/useChartResize';
import useChartConfig from './useChartConfig';

const XRANGE_MODULE = 'highcharts/modules/xrange';
const chartModules = [XRANGE_MODULE, CHART_PLUGINS.STOCK];

const ConnectionHistoryChartComponent = ({ assets, fromDate, toDate }) => {
    const { t: translate } = useTranslation();
    const chartOptions = useChartConfig(assets, fromDate, toDate, translate);
    const containerRef = useRef();
    const chartRef = useRef();
    useChartResize(containerRef, chartRef);

    if (!assets || assets?.length === 0) {
        return (
            <div className='connection-history-chart__empty'>
                {translate('ABB.Powertrain.Frontend.gatewayManagementNoConnectionHistory')}
            </div>
        );
    }
    const chartKey = `${fromDate}_${toDate}`;

    return (
        <React.Suspense fallback={<LoadingIndicator />}>
            <div ref={containerRef} className='connection-history-chart__container'>
                <Chart
                    key={chartKey}
                    ref={chartRef}
                    options={chartOptions}
                    isStatic={false}
                    container='connection-history-xrange-chart'
                    modules={chartModules}
                />
            </div>
        </React.Suspense>
    );
};

ConnectionHistoryChartComponent.propTypes = {
    assets: PropTypes.arrayOf(PropTypes.shape({
        assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        assetName: PropTypes.string,
        segments: PropTypes.arrayOf(PropTypes.shape({
            start: PropTypes.string,
            end: PropTypes.string,
            status: PropTypes.string,
        })),
    })),
    fromDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    toDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default ConnectionHistoryChartComponent;
